import { memo } from 'react';
import {
  S600,
  E600,
  ArrowDownIcon,
  ArrowUpIcon,
  Grid,
  G600,
  Typography,
  usePasswordStrength,
  useTranslations,
} from '@uniqkey-frontend/shared-app';

interface IUniqkeyAccessScoreStatisticsTooltipContentProps {
  masterPasswordStrength: number;
  isMasterPasswordReused?: boolean;
  hasReusedPasswords?: boolean;
}

const UniqkeyAccessScoreStatisticsTooltipContent = (
  props: IUniqkeyAccessScoreStatisticsTooltipContentProps,
) => {
  const {
    masterPasswordStrength, isMasterPasswordReused, hasReusedPasswords,
  } = props;
  const { t } = useTranslations();
  const { color } = usePasswordStrength({ strength: masterPasswordStrength });

  return (
    <Grid container>
      <Grid item container justifyContent="space-between">
        <Grid item py={0.5}>
          <Typography variant="caption" color={G600}>
            {t('uniqkeyAccessScoreStatisticsTooltipContent.masterPasswordStrength')}
            :&nbsp;
            <Typography variant="caption" component="span" color={color}>
              {masterPasswordStrength}
              %
            </Typography>
          </Typography>
        </Grid>
        <Grid item>
          {masterPasswordStrength ? (
            <>
              <ArrowUpIcon color={S600} height={11} />
              <Typography color={S600} component="span">+</Typography>
              <Typography variant="caption" color={G600}>
                {masterPasswordStrength}
                %
              </Typography>
            </>
          ) : (
            <Typography variant="caption" color={G600}>0%</Typography>
          )}
        </Grid>
      </Grid>
      <Grid item container justifyContent="space-between">
        <Grid item py={0.5}>
          <Typography variant="caption" color={G600}>
            {t('uniqkeyAccessScoreStatisticsTooltipContent.masterPasswordIsReused')}
            :&nbsp;
            <Typography
              variant="caption"
              component="span"
              color={isMasterPasswordReused ? E600 : S600}
            >
              {t(isMasterPasswordReused ? 'common.yes' : 'common.no')}
            </Typography>
          </Typography>
        </Grid>
        <Grid item>
          {isMasterPasswordReused && (
            <>
              <ArrowDownIcon color={E600} />
              <Typography color={E600} component="span">-</Typography>
              <Typography variant="caption" color={G600}>100%</Typography>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item container justifyContent="space-between">
        <Grid item py={0.5}>
          <Typography variant="caption" color={G600}>
            {t('uniqkeyAccessScoreStatisticsTooltipContent.hasReusedPasswords')}
            :&nbsp;
            <Typography
              variant="caption"
              component="span"
              color={hasReusedPasswords ? E600 : S600}
            >
              {t(hasReusedPasswords ? 'common.yes' : 'common.no')}
            </Typography>
          </Typography>
        </Grid>
        <Grid item>
          {hasReusedPasswords && (
            <>
              <ArrowDownIcon color={E600} />
              <Typography color={E600} component="span">-</Typography>
              <Typography variant="caption" color={G600}>40%</Typography>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(UniqkeyAccessScoreStatisticsTooltipContent);
